<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/trainee/traineeDashboard',
                    active: true,
                  },
                ]"></vs-breadcrumb>
                    </div>
                </div>
                <!-- New Design starts -->
                <div class="row mt-2">
                    <!-- col-md-4 trainings starts -->
                    <div class="col-md-4 mb-3">
                        <section class="events-panel">
                            <div class="events-panel__header">
                                <div>
                                    <h5>Events</h5>
                                    <small>
                                        <b>
                                            You have {{ inprogressTrainingCounter }} Ongoing Events
                                        </b>
                                    </small>
                                </div>
                                <span class="events-panel__pill">
                                    Latest Update
                                </span>
                            </div>
                            <div class="events-panel__search">
                                <input
                                    type="text"
                                    placeholder="Search events..."
                                    v-model="searchQueryTraining"
                                    class="events-panel__search-input"
                                />
                            </div>
                            <div class="events-panel__list">
                                <article
                                    class="event-card"
                                    v-for="(item, index) in strainingFilter"
                                    :key="index"
                                    :class="{ 'event-card--active': active_sp == item.training }"
                                    @click="handleEventCardSelect(item)"
                                >
                                    <div class="event-card__accent"></div>
                                    <div class="event-card__desktop">
                                        <div class="event-card__top">
                                            <div>
                                                <h6>{{ item.title }}</h6>
                                            </div>
                                            <i class="material-icons">play_circle_fill</i>
                                        </div>
                                        <div class="event-card__status">
                                            <span v-if="item.status == 'found'" class="status-tag status-tag--success">
                                                Training Completed
                                            </span>
                                            <span v-else-if="item.pre == 'nofound'" class="status-tag status-tag--warning">
                                                Pre Assessment Pending
                                            </span>
                                            <span v-else-if="item.post == 'nofound'" class="status-tag status-tag--warning">
                                                Post Assessment Pending
                                            </span>
                                            <span
                                                v-else
                                                :class="[
                                                    'status-tag',
                                                    item.pre ? 'status-tag--info' : 'status-tag--warning'
                                                ]"
                                            >
                                                {{ item.pre ? 'In Progress' : 'Pending' }}
                                            </span>
                                        </div>
                                        <div class="event-card__meta">
                                            <span>Start: {{ formattedDate(item.startdate) }}</span>
                                            <span>End: {{ formattedDate(item.enddate) }}</span>
                                        </div>
                                    </div>
                                    <div class="event-card__mobile">
                                        <div class="event-card__mobile-top">
                                            <h6>{{ item.title }}</h6>
                                            <p class="event-card__code">{{ item.training }}</p>
                                        </div>
                                        <div class="event-card__mobile-status">
                                            <span v-if="item.status == 'found'" class="status-tag status-tag--success">
                                                Training Completed
                                            </span>
                                            <span v-else-if="item.pre == 'nofound'" class="status-tag status-tag--warning">
                                                Pre Assessment Pending
                                            </span>
                                            <span v-else-if="item.post == 'nofound'" class="status-tag status-tag--warning">
                                                Post Assessment Pending
                                            </span>
                                            <span
                                                v-else
                                                :class="[
                                                    'status-tag',
                                                    item.pre ? 'status-tag--info' : 'status-tag--warning'
                                                ]"
                                            >
                                                {{ item.pre ? 'In Progress' : 'Pending' }}
                                            </span>
                                        </div>
                                        <div class="event-card__mobile-meta">
                                            <span>Start: {{ formattedDate(item.startdate) }}</span>
                                            <span class="event-card__mobile-separator"></span>
                                            <span>End: {{ formattedDate(item.enddate) }}</span>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </section>
                    </div>
                    <!-- col-md-4 trainings ends -->
                    <div
                        class="col-md-8 mb-3"
                        v-if="trainingSingle && (trainingType != 1 || this.IncompleteDiv || this.completeDiv)"
                        :id="completeDiv ? 'completeDiv' : 'incomcpleteDiv'"
                        ref="trainingDetails"
                    >
                        <div class="Training-pending d-flex flex-column" ref="scrollToDiv">
                            <div class="d-flex p-2">

                                <div class="training-title">
                                    <h6>{{ trainingSingle.title }}</h6>
                                    <small>
                                        <b>
                                            Start Date :
                                            {{ formattedDate(trainingSingle.startdate) }} End Date :
                                            {{ formattedDate(trainingSingle.enddate) }}
                                        </b>
                                    </small>
                                    <p>
                                        <b>{{ trainingSingle.venue }} ({{
                          trainingSingle.address

                        }})</b>
                                    </p>
                                </div>
                            </div>
                            <div class="options p-3">
                                <ul>
                                    <!-- li starts -->
                                    <li class="detail-card__step detail-card__actions-card">
                                        <div class="detail-card__actions-card-title">
                                            <h6>Event Resources</h6>
                                            <small>Quick access to everything you need</small>
                                        </div>
                                        <div class="resource-actions">
                                            <button
                                                v-if="canAccessEventResources"
                                                class="btn btn-info resource-action-btn"
                                                @click="downloadCertificate"
                                            >
                                                Download Certificate
                                            </button>
                                            <button
                                                v-if="canAccessEventResources"
                                                type="button"
                                                class="btn btn-warning resource-action-btn"
                                                @click="$router.push({ path: '/dashboard/Trainee/gallery', query: { training: trainingSingle.training_code } })"
                                            >
                                                Event Gallery
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-success resource-action-btn"
                                                @click="$router.push({ path: '/dashboard/Trainee/knowledgeBaseRepository' })"
                                            >
                                                View Event Material
                                            </button>
                                        </div>
                                    </li>
                                    <!-- li ends -->
                                    <!-- li starts -->

                                    <li class="option-1 d-flex">
                                        
                                        <div class="pr-3 w-50">
                                            <h6>Event Initiation</h6>
                                        </div>
                                        <div>
                                            <h6 class="detail-card__status status--complete">Completed</h6>
                                        </div>
                                        
                                    </li>
                                    <!-- li ends -->
                                    <!-- ------------------- -->
                                    <!-- li starts -->
                                    <li class="option-2 d-flex detail-card__step" v-if="hasAssessmentFeatures && this.preAssessment != null">
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>Pre Assessment</h6>
                                            </div>
                                            <h6 class="detail-card__status status--complete">Completed</h6>
                                        </div>
                                    </li>
                                    <li class="option-2 d-flex li-clr detail-card__step" v-else-if="hasAssessmentFeatures">
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>Pre Assessment</h6>
                                            </div>
                                            <h6 class="detail-card__status status--pending">Ready to start</h6>
                                        </div>
                                        <div
                                            class="detail-card__step-actions"
                                            v-if="
                                                trainingSingle.preassesment_status == 1 ||
                                                trainingSingle.preassesment_status == true
                                            "
                                        >
                                            <router-link
                                                class="detail-card__step-btn"
                                                :to="{
                                                    path: '/dashboard/Trainee/preassessment',
                                                    query: { training: trainingSingle.training_code },
                                                }"
                                            >
                                                Start Pre Assessment
                                            </router-link>
                                        </div>
                                    </li>
                                    <li class="option-2 d-flex detail-card__step" v-else>
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>Pre Assessment</h6>
                                            </div>
                                            <h6 class="detail-card__status status--na">N/A</h6>
                                        </div>
                                    </li>
                                    <!-- li ends -->

                                    <li class="option-2 d-flex detail-card__step" v-if="hasAssessmentFeatures && this.referenceCount >= 2">
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>References</h6>
                                            </div>
                                            <h6 class="detail-card__status status--complete">Completed</h6>
                                        </div>
                                    </li>
                                    <li class="option-2 d-flex li-clr detail-card__step" v-else-if="hasAssessmentFeatures">
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>References</h6>
                                            </div>
                                            <h6 class="detail-card__status status--pending">
                                                <span v-if="this.preAssessment != null">Ready</span>
                                                <span v-else>Pre Assessment Pending</span>
                                            </h6>
                                        </div>
                                        <div class="detail-card__step-actions" v-if="this.preAssessment != null">
                                            <router-link
                                                class="detail-card__step-btn"
                                                :to="{
                                                    path: '/dashboard/Trainee/addReference',
                                                    query: { training: trainingSingle },
                                                }"
                                            >
                                                Add References
                                            </router-link>
                                        </div>
                                    </li>
                                    <li class="option-2 d-flex detail-card__step" v-else>
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>References</h6>
                                            </div>
                                            <h6 class="detail-card__status status--na">N/A</h6>
                                        </div>
                                    </li>

                                    <!-- li starts -->
                                    <li class="option-2 d-flex li-clr-disabled detail-card__step" v-if="hasAssessmentFeatures && this.postAssessment != null">
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>Post Assessment</h6>
                                            </div>
                                            <h6 class="detail-card__status status--complete">Completed</h6>
                                        </div>
                                    </li>
                                    <li class="option-2 d-flex li-clr detail-card__step" v-else-if="hasAssessmentFeatures">
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>Post Assessment</h6>
                                            </div>
                                            <h6 class="detail-card__status status--pending">
                                                <template v-if="trainingSingle.postassesment_status == 1 || trainingSingle.postassesment_status == true">
                                                    <span
                                                        v-if="
                                                            this.preAssessment != null &&
                                                            trainingSingle.disableReference == true
                                                        "
                                                    >
                                                        Ready to start
                                                    </span>
                                                    <span
                                                        v-else-if="
                                                            trainingSingle.disableReference == false &&
                                                            this.referenceCount >= 2
                                                        "
                                                    >
                                                        Ready to start
                                                    </span>
                                                    <span v-else>References Pending</span>
                                                </template>
                                                <span v-else>Pending</span>
                                            </h6>
                                        </div>
                                        <div
                                            class="detail-card__step-actions"
                                            v-if="
                                                (this.preAssessment != null && trainingSingle.disableReference == true) ||
                                                (trainingSingle.disableReference == false && this.referenceCount >= 2)
                                            "
                                        >
                                            <router-link
                                                class="detail-card__step-btn"
                                                :to="{
                                                    path: '/dashboard/Trainee/postassessment',
                                                    query: { training: trainingSingle.training_code },
                                                }"
                                            >
                                                Start Post Assessment
                                            </router-link>
                                        </div>
                                    </li>
                                    <li class="option-2 d-flex detail-card__step" v-else>
                                        <div class="detail-card__summary">
                                            <div class="detail-card__label-block">
                                                
                                                <h6>Post Assessment</h6>
                                            </div>
                                            <h6 class="detail-card__status status--na">N/A</h6>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="row mb-2 p-3">
                                <div class="col-sm-12 pl-0">
                                    <h6 class="pl-3">Agenda Title</h6>
                                    
                                </div>
                                <div class="col-sm-12">
                                    <vs-tabs v-if="newArr.length > 0">
                                        <vs-tab v-for="(day, index) in newArr" :key="index" :label="'Day ' + day.day">
                                            <div class="row p-1">
                                                <div class="table-responsive">
                                                    <table class="table table-borderless">
                                                        <thead>
                                                            <tr style="border-bottom:1px solid #333">
                                                                <th>Event Title</th>
                                                                <th>Assign Trainer</th>
                                                                <th>Session</th>
                                                                <th>Start Time</th>
                                                                <th>End Time</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style="border-bottom:1px solid #333" v-for="(agenda, i) in day.data" :key="i">
                                                                <td style="width:30%">
                                                                    {{ trainingSingle.title }}
                                                                </td>
                                                                <td v-if="agenda.user">
                                                                    {{ agenda.user.name }}
                                                                </td>
                                                                <td v-else>N / A</td>
                                                                <td>{{ agenda.session }}</td>
                                                                <td>{{ agenda.fromtime }}</td>
                                                                <td>{{ agenda.totime }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </vs-tab>
                                    </vs-tabs>
                                    <div v-else>Agenda Not found</div>
                                </div>
                                <hr style="border-bottom:1px solid #333;opacity:0.5" />
                            </div>
                        </div>
                    </div>
                    <!-- col-md-8 training detail ends -->
                </div>
                <!-- New Design ends -->
                <!-- Modal -->
                <div class="modal2" v-if="isModalOpen">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content custom-modal">
                            <!-- Modal Header -->
                            <div class="modal-header border-0">
                                <h4 class="modal-title">
                                    <i class="material-icons align-middle mr-2">people_alt</i>
                                    Reference Details
                                </h4>
                                <button type="button" class="close modal-close-btn" @click="closeModal">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>

                            <!-- Modal body -->
                            <div class="modal-body pt-0">
                                <div class="table-container">
                                    <div class="table-responsive">
                                        <table class="table custom-table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Designation</th>
                                                    <th>Email ID</th>
                                                    <th>Contact Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in traingRef" v-bind:key="item.id">
                                                    <td>{{index+1}}</td>
                                                    <td class="text-capitalize font-weight-medium">
                                                        {{item.name}}
                                                    </td>
                                                    <td>
                                                        <span class="designation-badge">
                                                            {{ getDesignationTitle(item.designation_id) }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <a :href="'mailto:' + item.email" class="email-link">
                                                            {{item.email}}
                                                        </a>
                                                    </td>
                                                    <td>{{item.contactNo}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal close -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
import Navbar from "./Navbar";
import Sidebar from "./main-sidebar";
import "flatpickr/dist/flatpickr.css";
import {
    dateCheck
} from "@/utils/DateFormate";
export default {
    data: () => ({
        isModalOpen: false,
        traingRef: [],
        isSidebar: false,
        trainings: [],
        title: "",
        traineeId: "",
        active_sp: 0,
        active_pr: 0,
        completeDiv: false,
        IncompleteDiv: false,
        preAssessment: "",
        postAssessment: "",
        searchQueryTraining: "",
        feedbackstatus: "",
        projectId: "",
        searchstartDate: "",
        searchendDate: "",
        dateRange: [],
        cardDateOptions: {
            wrap: true,
            weekNumbers: true,
            mode: "range",
            maxDate: new Date().fp_incr(10),
            dateFormat: "d-m-Y"
        },
        traineeSearchId: "",
        active_tr: 0,
        agendasArray: [],
        newArr: [],
        trainingSingle: [],
        participatedTrainingCounter: 0,
        inprogressTrainingCounter: 0,
        referenceCount: 0,
        trainee: JSON.parse(localStorage.getItem("currentUser")).name,
        designationArr: [],
        isCompleted: false,
        trainingType : '',
        socialFields: [
            {
                label: 'X (Twitter)',
                icon: 'fa-brands fa-x-twitter',
                value: '',
                icon2: '🐤'
            },
            {
                label: 'Facebook',
                icon: 'fa-brands fa-facebook-f',
                value: '',
                icon2: '🟦'
            },
            {
                label: 'LinkedIn',
                icon: 'fa-brands fa-linkedin-in',
                value: '',
                icon2: '💼'
            },
            {
                label: 'Instagram',
                icon: 'fa-brands fa-instagram',
                value: '',
                icon2: '📷'
            },
            {
                label: 'Web Story',
                icon: 'fa-solid fa-globe',
                value: '',
                icon2: '🌐'
            }
        ],
    }),
    watch: {
        dateRange(date) {
            if (date != undefined && date != "") {
                this.searchstartDate = date.split(" to")[0];
                this.searchendDate = date.split("to ")[1];
                if (
                    this.searchstartDate != undefined &&
                    this.searchendDate != undefined
                ) {
                    this.openLoading();
                    axios
                        .get(
                            process.env.VUE_APP_BASE_PATH +
                            "/project/trainings/trainee/filterdate/" + this.searchstartDate + "/" + this.searchendDate + "/" + this.traineeSearchId + "/" + JSON.parse(localStorage.getItem("currentUser")).id)
                        .then(response => {
                            this.closeLoading();
                            if (response) {
                                this.trainingFilterArr = response.data
                            }
                        });
                }
            }
        }
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.showSingleTrainee();
        this.getDesignations();
    },
    methods: {
        dateCheck,
        formattedDate(tdate) {
            const [year, month, day] = tdate.split("-");
            return `${day}-${month}-${year}`;
        },
        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        showAssesments(traingId) {
            localStorage.setItem("traingId", traingId)
            this.trainingSingle = [];
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee/check/assesments/all/" +
                    traingId +
                    "/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.newArr = [];
                    this.agendasArray = [];
                    this.trainingSingle = response.data.traininigSingle;
                    this.trainingType = response.data?.traininigSingle?.typetraining_id;
                    this.fetchSocialLinks(traingId);
                    this.preAssessment = response.data.checkPreAssesment;
                    this.postAssessment = response.data.checkPostAssesment;
                    this.feedbackstatus = response.data.checkFeedback;
                    if (
                        this.preAssessment != null &&
                        this.postAssessment != null &&
                        this.feedbackstatus != null
                    ) {
                        this.completeDiv = true;
                        this.IncompleteDiv = false;
                        
                    } else {
                        this.IncompleteDiv = true;
                        this.completeDiv = false;
                        
                    }
                    if (
                        response.data &&
                        response.data.agenda &&
                        response.data.agenda.length > 0
                    ) {
                        this.agendasArray = response.data.agenda;
                        this.agendasArray.forEach((val) => {
                            if (this.newArr.some((person) => person.day === val.days)) {
                                this.dayIndex = this.newArr.map((e) => e.day).indexOf(val.days);
                                this.newArr[this.dayIndex].data.push(val);
                            } else {
                                this.newArr.push({
                                    day: val.days,
                                    data: [val],
                                });
                            }
                        });

                    }
                    //this.activatePr(response.data[0].id);
                    //this.activateTr(response.data[0].id);
                });

            // call reference count
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/references/counts/" +
                    traingId + "/" + JSON.parse(localStorage.getItem("currentUser")).id
                )
                .then(response => {
                    this.referenceCount = response.data.count
                })
        },

        showSingleTrainee: function showSingleTrainee() {
            this.openLoading();

            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee-single/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/show"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.traineeId = response.data.id;
                    localStorage.setItem('traineeId', response.data.id);
                    this.showAllTrainings(this.traineeId);
                });
            setTimeout(() => {
                this.scrollToDiv();
            }, 2000);

        },
        activateSubP: function activateSubP(id) {
            this.active_sp = id;
        },
        handleEventCardSelect(item) {
            this.showAssesments(item.training);
            this.activateSubP(item.training);
            this.scrollToDetailsSection();
        },
        scrollToDetailsSection() {
            if (typeof window === "undefined" || window.innerWidth > 768) {
                return;
            }
            this.$nextTick(() => {
                const detailSection = this.$refs.trainingDetails;
                if (detailSection && typeof detailSection.scrollIntoView === "function") {
                    detailSection.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            });
        },
        activatePr: function activatePr(id) {
            this.active_pr = id;
        },
        activateTr: function activateTr(id) {
            this.active_tr = id;
        },

        showAllTrainings: function showAllTrainings(traineeId) {
            this.traineeSearchId = traineeId;
            // this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee/trainings/knowledegebase/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/get/" +
                    traineeId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.inprogressTrainingCounter = 0;
                    this.participatedTrainingCounter = 0;
                    this.trainings = response.data;
                    response.data.forEach((element) => {
                        if (element.status == "nofound") {

                            this.inprogressTrainingCounter++;
                        } else {

                            this.participatedTrainingCounter++;
                        }
                    });
                    this.showAssesments(response.data[0].training);
                });
        },
        downloadCertificate() {
            // First check training type
            if (this.trainingSingle.typetraining_id != 1) {
                
                if (dateCheck(this.trainingSingle.enddate) === true) {
                    if (this.trainingSingle.download_certificate_status === true) {
                        this.$router.push({
                            path: '/dashboard/Trainee/certificates',
                            query: {
                                trainingId: this.trainingSingle.training_code
                            },
                        });
                    } else {
                        this.toastError('Certificate download is not enabled yet.');
                    }
                } else {
                    this.toastError('The Certificate can be downloaded on the last day of the training.');
                }

            } else {
                // For type-1 trainings, check both pre and post assessments
                if (this.preAssessment != null && this.postAssessment != null) {
                    if (dateCheck(this.trainingSingle.enddate) === true) {
                        if (this.trainingSingle.download_certificate_status === true) {
                            this.$router.push({
                                path: '/dashboard/Trainee/certificates',
                                query: {
                                    trainingId: this.trainingSingle.training_code
                                },
                            });
                        } else {
                            this.toastError("Certificate can be downloaded once enabled by the UNODC's Programme Officer on the last day of the event and after.");
                        }
                    } else {
                        this.toastError("Certificate can be downloaded once enabled on the last day of the event and after.");
                    }
                } else {
                    this.toastError('You must complete both pre-assessment and post-assessment to download the certificate.');
                }
            }
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Files have been Uploaded, consectetur",
            });
        },
        scrollToDiv() {
            if (this.$refs.scrollToDiv) {
                this.$refs.scrollToDiv.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },
        showRefrances(ref) {
            this.traingReferences(ref)
            this.isModalOpen = true

        },
        closeModal() {
            this.isModalOpen = false;
        },
        traingReferences(ref) {

            axios
                .get(process.env.VUE_APP_BASE_PATH + "/references/get-assigned-references-to-training/" + JSON.parse(localStorage.getItem("currentUser")).id + "/" + ref.id)
                .then(response => {
                    this.traingRef = response.data;
                });
        },
        fetchSocialLinks(trainingId) {
            const id = trainingId || this.trainingSingle?.id || this.trainingSingle?.training;
            if (!id) return;
            this.socialFields.forEach(field => field.value = '');
            axios
                .get(`${process.env.VUE_APP_BASE_PATH}/training/media/${id}`)
                .then(response => {
                    const media = response.data.media || {};
                    this.socialFields[0].value = media.twitter_link || '';
                    this.socialFields[1].value = media.facebook_link || '';
                    this.socialFields[2].value = media.linkedin_link || '';
                    this.socialFields[3].value = media.insta_link || '';
                    this.socialFields[4].value = media.web_link || '';
                })
                .catch(error => {
                    console.error("Failed to load social links", error);
                });
        },
        copySingle(link) {
            if (!link?.value?.trim()) return;
            const eventLabel = this.trainingSingle?.title || "Event";
            const formattedText = `*Event: ${eventLabel}*\n${link.icon2} *${link.label}:*\n${link.value}`;
            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess(`${link.label} link copied!`);
            });
        },
        copyAllLinks() {
            const filledLinks = this.filteredSocialFields;
            if (!filledLinks.length) return;
            const eventLabel = this.trainingSingle?.title || "Event";
            let formattedText = `*Event: ${eventLabel}*`;
            formattedText += '\n\n' + filledLinks.map(link =>
                `${link.icon2} *${link.label}:*\n${link.value}`
            ).join('\n\n');
            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess('All links copied!');
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        getDesignations() {
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all")
                .then(response => {
                    this.designationArr = response.data;
                });
        },
        getDesignationTitle(id) {
            const designation = this.designationArr.find(d => d.id === id);
            return designation ? designation.title : 'Unknown';
        },
        canStartPostAssessment() {
            return (this.preAssessment && this.trainingSingle.disableReference) ||
                (!this.trainingSingle.disableReference && this.referenceCount >= 2);
        },
        getReferenceLink() {
            return {
                path: '/dashboard/Trainee/addReference',
                query: {
                    training: this.trainingSingle
                }
            };
        },
        getAssessmentLink(type) {
            return {
                path: `/dashboard/Trainee/${type}`,
                query: {
                    training: this.trainingSingle.training_code
                }
            };
        }
    },
    computed: {
        strainingFilter: function () {
            return this.trainings.filter((items) => {
                for (var item in items) {

                    if (String(items[item]).toLowerCase().indexOf(this.searchQueryTraining.toLowerCase()) !== -1) {
                        return true;
                    }
                }
                return false;
            });
        },
        filteredSocialFields() {
            return this.socialFields.filter(field => (field.value || '').trim());
        },
        hasSocialLinks() {
            return this.filteredSocialFields.length > 0;
        },
        canAccessEventResources() {
            if (this.trainingType != 1) {
                return true;
            }
            return (
                this.preAssessment != null &&
                this.postAssessment != null &&
                this.referenceCount >= 2
            );
        },
        hasAssessmentFeatures() {
            return this.trainingType == 1;
        }
    },
};
</script>

<style scoped>
.modal-btn {
    padding: 0px 50px;
    height: 30px;
    border-radius: 10px;
}

#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
       
    }
    .training-code{
        display: none;
    }
    .btn-info {
        padding: 7px 4px;
        font-size: 13px;
        width: 100%;
        margin: 5px 0;
        border-radius: 5px;
    }
}

.active {
    background: #dff0d8 !important;
}

.margin_bottom_admin {
    margin-bottom: 30px;
}

.active.training-title-cards {
    color: #fff !important;
}

ul.date-ul {
    display: inline-flex;
}

ul li {
    cursor: pointer;
}

.date-ul li.start-date {
    padding-right: 35px;
}

.cards-row {
    margin-top: 10px !important;
}

.card-col {
    padding: 5px !important;
}

.main-card {
    color: #6c757d;
    border: 1px dotted #07a7e14f;
}

.main-card:hover {
    border: 1px solid #07a7e14f;
}

.training-title {
    font-weight: 500;

}

.training-title-cards {
    font-size: 15px;
    font-weight: 500;
}

.con-vs-card.withHover:hover img {
    -webkit-transform: scale(1);
    transform: scale(1);
}

.cardheader {
    display: inline-flex;
}

@media (max-width: 768px) {

    .card-col {
        width: 100% !important;
    }

    ul.date-ul {
        margin-top: 5px;
    }

    .date-ul li.start-date {
        padding-right: 26px;
    }

    .training-title {
        font-size: 14px;
    }
}

@media (max-width: 991.98px) {
    .date-ul li.start-date {
        padding-right: 26px;
    }

    .card-col {
        width: 100% !important;
    }

    ul.date-ul {
        margin-top: 5px;
    }
}

.p-0 {
    padding: 0px;
}

.p-t-0 {
    padding-top: 0px;
}

.p-b-0 {
    padding-bottom: 0px;
}

.p-l-0 {
    padding-left: 0px;
}

.p-r-0 {
    padding-right: 0px;
}

.m-0 {
    margin: 0px;
}

.m-t-0 {
    margin-top: 0px;
}

.m-b-0 {
    margin-bottom: 0px;
}

.m-l-0 {
    margin-left: 0px;
}

.m-r-0 {
    margin-right: 0px;
}

.p-5 {
    padding: 5px;
}

.p-t-5 {
    padding-top: 5px;
}

.p-b-5 {
    padding-bottom: 5px;
}

.p-l-5 {
    padding-left: 5px;
}

.p-r-5 {
    padding-right: 5px;
}

.m-5 {
    margin: 5px;
}

.m-t-5 {
    margin-top: 5px;
}

.m-b-5 {
    margin-bottom: 5px;
}

.m-l-5 {
    margin-left: 5px;
}

.m-r-5 {
    margin-right: 5px;
}

.p-10 {
    padding: 10px;
}

.p-t-10 {
    padding-top: 10px;
}

.p-b-10 {
    padding-bottom: 10px;
}

.p-l-10 {
    padding-left: 10px;
}

.p-r-10 {
    padding-right: 10px;
}

.m-10 {
    margin: 10px;
}

.m-t-10 {
    margin-top: 10px;
}

.m-b-10 {
    margin-bottom: 10px;
}

.m-l-10 {
    margin-left: 10px;
}

.m-r-10 {
    margin-right: 10px;
}

.p-15 {
    padding: 15px;
}

.p-t-15 {
    padding-top: 15px;
}

.p-b-15 {
    padding-bottom: 15px;
}

.p-l-15 {
    padding-left: 15px;
}

.p-r-15 {
    padding-right: 15px;
}

.m-15 {
    margin: 15px;
}

.m-t-15 {
    margin-top: 15px;
}

.m-b-15 {
    margin-bottom: 15px;
}

.m-l-15 {
    margin-left: 15px;
}

.m-r-15 {
    margin-right: 15px;
}

.p-20 {
    padding: 20px;
}

.p-t-20 {
    padding-top: 20px;
}

.p-b-20 {
    padding-bottom: 20px;
}

.p-l-20 {
    padding-left: 20px;
}

.p-r-20 {
    padding-right: 20px;
}

.m-20 {
    margin: 20px;
}

.m-t-20 {
    margin-top: 20px;
}

.m-b-20 {
    margin-bottom: 20px;
}

.m-l-20 {
    margin-left: 20px;
}

.m-r-20 {
    margin-right: 20px;
}

.p-25 {
    padding: 25px;
}

.p-t-25 {
    padding-top: 25px;
}

.p-b-25 {
    padding-bottom: 25px;
}

.p-l-25 {
    padding-left: 25px;
}

.p-r-25 {
    padding-right: 25px;
}

.m-25 {
    margin: 25px;
}

.m-t-25 {
    margin-top: 25px;
}

.m-b-25 {
    margin-bottom: 25px;
}

.m-l-25 {
    margin-left: 25px;
}

.m-r-25 {
    margin-right: 25px;
}

.p-30 {
    padding: 30px;
}

.p-t-30 {
    padding-top: 30px;
}

.p-b-30 {
    padding-bottom: 30px;
}

.p-l-30 {
    padding-left: 30px;
}

.p-r-30 {
    padding-right: 30px;
}

.m-30 {
    margin: 30px;
}

.m-t-30 {
    margin-top: 30px;
}

.m-b-30 {
    margin-bottom: 30px;
}

.m-l-30 {
    margin-left: 30px;
}

.m-r-30 {
    margin-right: 30px;
}

.p-35 {
    padding: 35px;
}

.p-t-35 {
    padding-top: 35px;
}

.p-b-35 {
    padding-bottom: 35px;
}

.p-l-35 {
    padding-left: 35px;
}

.p-r-35 {
    padding-right: 35px;
}

.m-35 {
    margin: 35px;
}

.m-t-35 {
    margin-top: 35px;
}

.m-b-35 {
    margin-bottom: 35px;
}

.m-l-35 {
    margin-left: 35px;
}

.m-r-35 {
    margin-right: 35px;
}

.p-40 {
    padding: 40px;
}

.p-t-40 {
    padding-top: 40px;
}

.p-b-40 {
    padding-bottom: 40px;
}

.p-l-40 {
    padding-left: 40px;
}

.p-r-40 {
    padding-right: 40px;
}

.m-40 {
    margin: 40px;
}

.m-t-40 {
    margin-top: 40px;
}

.m-b-40 {
    margin-bottom: 40px;
}

.m-l-40 {
    margin-left: 40px;
}

.m-r-40 {
    margin-right: 40px;
}

.p-45 {
    padding: 45px;
}

.p-t-45 {
    padding-top: 45px;
}

.p-b-45 {
    padding-bottom: 45px;
}

.p-l-45 {
    padding-left: 45px;
}

.p-r-45 {
    padding-right: 45px;
}

.m-45 {
    margin: 45px;
}

.m-t-45 {
    margin-top: 45px;
}

.m-b-45 {
    margin-bottom: 45px;
}

.m-l-45 {
    margin-left: 45px;
}

.m-r-45 {
    margin-right: 45px;
}

.p-50 {
    padding: 50px;
}

.p-t-50 {
    padding-top: 50px;
}

.p-b-50 {
    padding-bottom: 50px;
}

.p-l-50 {
    padding-left: 50px;
}

.p-r-50 {
    padding-right: 50px;
}

.m-50 {
    margin: 50px;
}

.m-t-50 {
    margin-top: 50px;
}

.m-b-50 {
    margin-bottom: 50px;
}

.m-l-50 {
    margin-left: 50px;
}

.m-r-50 {
    margin-right: 50px;
}

.v-b {
    vertical-align: bottom;
}

.card .card-header {
    background-color: transparent;
    border-bottom: none;
    padding: 20px;
    position: relative;
}

.latest-update-card .card-block {
    padding-top: 0;
}

.latest-update-card .card-block .latest-update-box {
    position: relative;
}

.latest-update-card .card-block .latest-update-box:after {
    content: "";
    position: absolute;
    background: #ebebeb;
    height: 100%;
    width: 3px;
    top: 0;
    left: 19px;
    z-index: 1;
}

.latest-update-card .card-block .latest-update-box .update-meta {
    z-index: 2;
}

.latest-update-card .card-block .latest-update-box .update-meta .update-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    padding: 7px 8px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #fff;
}

.latest-update-card .card-block .update-icon.bg-c-red {
    -webkit-box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
    box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-blue {
    -webkit-box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
    box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-green {
    -webkit-box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
    box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
}

.latest-update-card .card-block .update-icon.bg-c-yellow {
    -webkit-box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
    box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
}

.latest-update-card .card-block .update-icon.ring {
    border-width: 3px;
    width: 15px;
    height: 15px;
    padding: 0;
    display: block;
    margin-left: 13px;
    background: #fff;
}

.latest-update-card .card-block .latest-update-box .update-meta i.update-icon {
    margin-left: 4px;
    margin-right: 19px;
}

.latest-update-card .card-block .update-icon {
    padding: 0;
    width: 40px;
    height: 40px;
}

.bg-c-lite-blue {
    background: -webkit-gradient(linear-gradient(to right, #06a6e0, #00d2d6));
    background: linear-gradient(to right, #06a6e0, #00d2d6);
}

.bg-c-lite-purple {
    background: -webkit-gradient(linear-gradient(to right, #955cf9, #96a5f9));
    background: linear-gradient(to right, #955cf9, #96a5f9);
}

.bg-c-lite-pink {
    background: -webkit-gradient(linear-gradient(to right, #fe5d70, #fe909d));
    background: linear-gradient(to right, #fe5d70, #fe909d);
}

@media only screen and (max-width: 575px) {
    .latest-update-card .card-block .latest-update-box:after {
        display: none;
    }

    .latest-update-card .card-block .latest-update-box .update-meta {
        z-index: 2;
        min-width: 100%;
        text-align: left !important;
        margin-bottom: 15px;
        border-top: 1px solid #f1f1f1;
        padding-top: 15px;
    }
}

.trainings {
    background-color: #e6f4ff;
    border: 2px solid #9fdcf7;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}

.crd-title {
    margin-top: 10px;
}

.crd-title h5 {
    text-transform: uppercase;
}

.crd-title small b {
    font-size: 13 px;
    color: #fc4243;
    text-transform: capitalize;
}

.clr-orange {
    color: #ef8100;
}

.clr-green {
    color: #a4c639;
}

.clr-blue {
    color: #00a4ea;
}

b {
    color: #080808;
    font-size: 13px;
}

.add-new {
    position: absolute;
    width: 90%;
    bottom: 2px;
}

.bg-clr-orange {
    background-color: #fff2e5;
    padding: 10px;
}

.bg-clr-green {
    background-color: #f9ffe6;
    padding: 10px;
}

.bg-clr-blue {
    background-color: #e6f4ff;
    padding: 10px;
}

.add-new h6 {
    color: #080808;
    font-size: 15px;
}

.list-ul {
    padding: 0px !important;
}

/* .display-li {
  display: flex;
  justify-content: space-between;
} */
.short-title {
    padding: 8px 4px 8px 12px;
}

.md-title {
    padding: 0px 4px;
}

.modal-dialog {
    background: transparent !important;
}

.modal-dialog input {
    border-radius: 5px !important;
    height: 32px !important;
}

#bv-modal-example___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

#bv-modal-example2___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

#bv-modal-example3___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

.active.active-bg {
    background: #fbecde !important;
}

.not-full {
    padding: 4px 4px !important;
}

.msg-danger small b {
    font-size: 11px;
    color: #fc4243;
    text-transform: uppercase;
}

.msg-success small b {
    font-size: 11px;
    color: #4ed17a;
    text-transform: uppercase;
}

li.display-li:hover {
    background-color: #c9e7ff;
    /* color: #fff !important; */
}

.Training-pending {
    border: 2px solid #fff0a2;
    background-color: #fffae5;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}

/* #76b173 */
.Training-completed {
    border: 2px solid #beffbc;
    background-color: #e6ffe5;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}

.training-completed-code-clr {
    color: #76b173;
}

.training-code-clr {
    color: #eadb89;
}

.li-clr {
    color: #fc4243;
    text-transform: capitalize;
}

.li-clr b {
    color: #fc4243;
}

.test-status h6 {
    text-decoration: underline;
}

.li-clr-disabled {
    color: dimgray;
    text-transform: capitalize;
}

.li-clr-disabled b {
    color: dimgray;
}

.view-material-link {
   margin-top: 8px;
}

.view-material-link p b {
    text-decoration: underline;
    text-transform: capitalize;
    font-size: 15px;
}

.download-certificates {
    position: relative !important;
    bottom: 0px !important;
    top: 7px !important;
    margin: 0px !important;

}

.download-certificates p b {
    text-decoration: underline;
    text-transform: capitalize;
    font-size: 15px;
}

.date-style b {
    font-size: 12px;
}

.pl-custom {
    padding-left: 3rem !important;
}

.pl-custom-2 {
    padding-left: 2rem !important;
}

.option-1 {
    padding: 5px;
    border: 1px solid #cec182;
}

.option-2 {
    padding: 5px;
    border: 1px solid #cec182;
}

.option-1-comp {
    padding: 5px;
    border: 1px solid #cdffcb !important;
}

.noUnderline {
    text-decoration: none !important
}

.events-panel {
    background: #ffffff;
    border-radius: 18px;
    padding: 1.5rem;
    height: 100%;
    min-height: 85vh;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    box-shadow: 0 20px 40px rgba(6, 166, 224, 0.12);
    border: 1px solid rgba(6, 166, 224, 0.2);
}

.events-panel__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.events-panel__header h5 {
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    font-size: 0.95rem;
}

.events-panel__header small b {
    font-size: 0.8rem;
    color: #5f5f5f;
}

.events-panel__pill {
    background: linear-gradient(135deg, #06a6e0, #64d5f3);
    color: white;
    padding: 0.4rem 0.75rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.05em;
}

.events-panel__search {
    width: 100%;
}

.events-panel__search-input {
    width: 100%;
    border-radius: 12px;
    border: 1px solid rgba(6, 166, 224, 0.35);
    padding: 0.65rem 1rem;
    font-size: 0.9rem;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.events-panel__search-input:focus {
    border-color: #06a6e0;
    box-shadow: 0 0 0 2px rgba(6, 166, 224, 0.2);
}

.events-panel__list {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-right: 0.4rem;
}

.event-card {
    position: relative;
    background: #f8fbff;
    border-radius: 16px;
    padding: 1.1rem 1.2rem 1.2rem 2rem;
    border: 1px solid rgba(6, 166, 224, 0.15);
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.event-card--active {
    transform: translateY(-2px);
    box-shadow: 0 15px 30px rgba(6, 166, 224, 0.25);
}

.event-card__accent {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 6px;
    border-radius: 16px 0 0 16px;
    background: linear-gradient(180deg, #06a6e0 0%, #0078b5 100%);
}

.event-card__desktop {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.event-card__desktop .event-card__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.event-card__desktop h6 {
    margin: 0;
    font-size: 1rem;
    color: #0c2f5c;
}

.event-card__code {
    font-size: 0.8rem;
    color: #6b6b6b;
    margin: 0.1rem 0 0;
}

.event-card__desktop i.material-icons {
    color: #06a6e0;
    font-size: 28px;
}

.event-card__status {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
}

.status-tag {
    padding: 0.25rem 0.7rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.status-tag--success {
    background: rgba(52, 211, 153, 0.2);
    color: #22c55e;
}

.status-tag--warning {
    background: rgba(251, 191, 36, 0.2);
    color: #f59e0b;
}

.status-tag--info {
    background: rgba(6, 166, 224, 0.2);
    color: #0369a1;
}

.event-card__meta {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    color: #536275;
}

.event-card__mobile {
    display: none;
    flex-direction: column;
    gap: 0.6rem;
}

.event-card__mobile-top h6 {
    margin: 0;
    color: #0a2a51;
}

.event-card__mobile-status {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
}

.event-card__mobile-meta {
    display: flex;
    justify-content: space-between;
    font-size: 0.85rem;
    color: #475569;
    align-items: center;
}

.event-card__mobile-separator {
    flex: 1;
    border-bottom: 1px dashed rgba(71, 85, 105, 0.3);
    margin: 0 0.5rem;
}

@media (max-width: 768px) {
    .events-panel {
        min-height: auto;
        max-height: none;
        padding: 1rem;
    }

    .events-panel__header {
        flex-direction: column;
        align-items: flex-start;
    }

    .event-card {
        padding: 1rem 1rem 1rem 1.25rem;
    }

    .event-card__desktop {
        display: none;
    }

    .event-card__mobile {
        display: flex;
    }

    .event-card__mobile-status {
        gap: 0.3rem;
    }

    .event-card__mobile-meta {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.35rem;
    }

    .events-panel__list {
        max-height: none;
    }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
    .trainings {
        min-height: auto;
        max-height: none;
    }

    .Training-pending,
    .Training-completed {
        min-height: auto;
        max-height: none;
    }

    .d-sm-flex {
        flex-direction: row !important; /* Override previous column direction */
    }
    
    .md-title {
        flex: 1;
        padding-right: 10px;
    }
    
    .pl-custom {
        padding-left: 0 !important;
        margin-left: auto;
    }
    
    .material-icons.large {
        font-size: 24px;
    }
    
    .display-li {
        padding: 8px 12px;
    }
}

/* Tablet Responsive Styles */
@media (min-width: 769px) and (max-width: 1024px) {
    .trainings,
    .Training-pending,
    .Training-completed {
        min-height: 60vh;
    }

    .pl-custom {
        padding-left: 1rem !important;
    }

    .pl-custom-2 {
        padding-left: 1rem !important;
    }
}

/* Modal Styling */
.modal2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.custom-modal {
    border: none;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    width: 100%;
}

.modal-header {
    padding: 1.5rem;
    background: #f8f9fa;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.modal-title {
    color: #2c3e50;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
}

.modal-title i {
    color: #06a6e0;
}

.modal-close-btn {
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    transition: background-color 0.3s;
}

.modal-close-btn:hover {
    background-color: #e9ecef;
}

.modal-body {
    padding: 1.5rem;
    background: #fff;
}

.table-container {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
}

.custom-table {
    margin-bottom: 0;
    width: 100%;
}

.custom-table thead th {
    background: #f8f9fa;
    border-top: none;
    border-bottom: 2px solid #e9ecef;
    color: #6c757d;
    font-weight: 600;
    padding: 1rem;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.custom-table tbody tr {
    transition: background-color 0.3s;
}

.custom-table tbody tr:hover {
    background-color: #f8f9fa;
}

.custom-table td {
    padding: 1rem;
    vertical-align: middle;
    border-top: 1px solid #e9ecef;
}

.designation-badge {
    display: inline-block;
    padding: 0.35em 0.65em;
    font-size: 0.75em;
    font-weight: 500;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    background-color: #e6f4ff;
    color: #06a6e0;
}

.email-link {
    color: #06a6e0;
    text-decoration: none;
    transition: color 0.3s;
}

.email-link:hover {
    color: #0056b3;
    text-decoration: underline;
}

.font-weight-medium {
    font-weight: 500;
}

/* Responsive Modal */
@media (max-width: 768px) {
    .modal2 {
        align-items: flex-start;
        padding: 1rem;
    }

    .modal-dialog {
        margin: 0;
        width: 100%;
        max-width: 100%;
    }
    
    .custom-modal {
        border-radius: 8px;
        max-height: calc(100vh - 2rem);
        overflow-y: auto;
    }
    
    .modal-header {
        padding: 1rem;
    }
    
    .modal-body {
        padding: 1rem;
    }
    
    .custom-table {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
    
    .custom-table td,
    .custom-table th {
        min-width: 120px;
        white-space: nowrap;
    }
    
    .modal-title {
        font-size: 1.1rem;
    }
    
    .designation-badge {
        font-size: 0.7em;
        padding: 0.25em 0.5em;
    }
}

.Training-pending {
    background: linear-gradient(145deg, #f4fbff 0%, #ffffff 60%, #e6f4ff 100%);
    border-radius: 26px;
    border: none;
    padding: 1.75rem;
    box-shadow: 0 25px 45px rgba(6, 166, 224, 0.18);
    color: #0c1f3b;
}

.Training-pending .training-title h6 {
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 0.35rem;
}

.Training-pending .training-title small {
    color: #5b6c82;
    display: block;
    margin-bottom: 0.5rem;
}

.Training-pending .training-title p {
    margin: 0;
    color: #1c2b45;
    font-weight: 600;
}

.options.training-detail-card__body {
    background: rgba(255, 255, 255, 0.95);
    margin-top: 1.1rem;
    padding: 1.3rem;
    border-radius: 18px;
    box-shadow: 0 12px 30px rgba(6, 166, 224, 0.12);
}

.options.training-detail-card__body .download-certificates {
    margin-bottom: 0.8rem;
}

.options.training-detail-card__body .view-material-link {
    margin-bottom: 1rem;
}

.options ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0.85rem;
    padding: 0;
    margin: 0;
}

.options ul li {
    list-style: none;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid rgba(6, 166, 224, 0.18);
    padding: 1rem 1.25rem;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    box-shadow: 0 15px 30px rgba(6, 166, 224, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.options ul li:hover {
    transform: translateY(-3px);
    box-shadow: 0 25px 45px rgba(6, 166, 224, 0.2);
}

.options ul li .pr-3 p {
    margin: 0;
    font-size: 0.85rem;
    color: #06a6e0;
    font-weight: 700;
}

.options ul li div h6 {
    margin: 0;
    font-weight: 600;
}

.view-material-link p {
    margin: 0;
    padding: 0.4rem 0;
    font-size: 0.95rem;
}

.view-material-link a {
    color: #06a6e0;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.Training-pending .row.mb-2.p-3 {
    background: #fff;
    border-radius: 20px;
    padding: 1.6rem;
    box-shadow: 0 25px 40px rgba(6, 166, 224, 0.12);
}

.Training-pending .table-responsive {
    box-shadow: none;
}

.Training-pending table th,
.Training-pending table td {
    font-size: 0.9rem;
    color: #1c2440;
    border-top: none !important;
}

.social-card {
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 25px 40px rgba(6, 166, 224, 0.15);
    max-width: 640px;
    margin: 0 auto;
    border: 1px solid rgba(6, 166, 224, 0.25);
}

.social-card__header {
    background: linear-gradient(135deg, #06a6e0, #00a6ff);
    color: #fff;
    padding: 16px 22px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.social-card__copy,
.social-card__row-copy {
    background: transparent;
    border: none;
    font-size: 1.15rem;
    cursor: pointer;
    color: inherit;
}

.social-card__body {
    background: #fff;
    padding: 18px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.social-card__row {
    background: #f4f7fb;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px dashed rgba(6, 166, 224, 0.3);
}

.social-card__row-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    margin-bottom: 6px;
}

.social-card__row p {
    margin: 0;
    padding-left: 8px;
    color: #0f172a;
    word-break: break-all;
}

.social-card__row-copy {
    color: #06a6e0;
}

@media (max-width: 768px) {
    .Training-pending {
        padding: 1.25rem;
    }

    .options ul {
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    }

    .Training-pending .row.mb-2.p-3,
    .social-card {
        padding: 1rem;
    }
}
 
.detail-card__step { 
  width: 100%; 
  border-radius: 16px; 
  background: #ffffff; 
  border: 1px solid rgba(6, 166, 224, 0.22); 
  padding: 0.8rem; 
  display: flex; 
  flex-direction: column; 
  gap: 0.45rem; 
  box-shadow: 0 10px 24px rgba(6, 166, 224, 0.12); 
} 
.detail-card__summary { 
  width: 100%; 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
  gap: 0.65rem; 
} 
.detail-card__label-block { 
  display: flex; 
  align-items: center; 
  gap: 0.5rem; 
} 
.detail-card__step-number p { 
  margin: 0; 
  font-size: 0.85rem; 
  font-weight: 700; 
  color: #06a6e0; 
} 
.detail-card__status { 
  margin: 0; 
  font-size: 0.85rem; 
  font-weight: 600; 
  color: #1f2a44; 
  text-transform: capitalize; 
} 
.detail-card__status.status--complete {
  color: #22c55e;
}
.detail-card__status.status--pending {
  color: #f59e0b;
}
.detail-card__status.status--na {
  color: #94a3b8;
}
.detail-card__step-actions { 
  width: 100%; 
  display: flex; 
  justify-content: flex-end; 
} 
.detail-card__step-btn { 
  border-radius: 999px; 
  padding: 0.45rem 1.25rem; 
  font-size: 0.78rem; 
  font-weight: 600; 
  text-transform: uppercase;
  letter-spacing: 0.08em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: linear-gradient(135deg, #06a6e0, #3fb3ff, #64d5f3);
  color: #ffffff;
  box-shadow: 0 12px 24px rgba(6, 166, 224, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-decoration: none;
} 
.detail-card__step-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 32px rgba(6, 166, 224, 0.35);
}
.detail-card__actions-card {
  grid-column: 1 / -1;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(120deg, rgba(6, 166, 224, 0.08), rgba(100, 213, 243, 0.1));
}
.detail-card__actions-card-title {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.35rem;
}
.detail-card__actions-card-title small {
  color: #5f6b80;
  font-weight: 500;
}
.resource-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.9rem;
}
.resource-action-btn {
  flex: 1 1 200px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  box-shadow: 0 12px 20px rgba(6, 166, 224, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.resource-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 30px rgba(6, 166, 224, 0.25);
}


@media (max-width: 768px) { 
  .options ul { 
    grid-template-columns: 1fr; 
    width: calc(100% + 1.5rem);
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  } 
  .options ul li,
  .options ul li.detail-card__step { 
    width: 100%; 
  } 
  .options {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .detail-card__summary { 
    flex-wrap: wrap; 
  } 
  .detail-card__step-actions { 
    justify-content: flex-end; 
  } 
  .detail-card__step-btn { 
    width: 100%; 
  } 
  .detail-card__actions-card {
    padding: 1rem;
  }
  .resource-actions {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.4rem;
  }
  .resource-action-btn {
    width: auto;
    min-width: 0;
    font-size: 0.72rem;
    padding: 0.3rem 0.9rem;
    border-radius: 999px;
    line-height: 1.2;
  }
  .options ul li.option-1 .detail-card__status,
  .options ul li.option-1-comp .detail-card__status {
    padding-left: 0.75rem;
    display: inline-block;
  }
} 
</style>
